/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemMultipleSelectionErrorMessage } from './formPagePropertyItemMultipleSelectionErrorMessage';
import { FormPagePropertyItemMultipleSelectionInputFormat } from './formPagePropertyItemMultipleSelectionInputFormat';
import { FormPagePropertyItemMultipleSelectionCandidate } from './formPagePropertyItemMultipleSelectionCandidate';
import { FormPagePropertyItemSelectionRequiredSubtext } from './formPagePropertyItemSelectionRequiredSubtext';
import { FormPagePropertyItemMultipleSelectionItemDefinition } from './formPagePropertyItemMultipleSelectionItemDefinition';


export interface FormPagePropertyItemMultipleSelectionAllOf { 
    type: FormPagePropertyItemMultipleSelectionAllOf.TypeEnum;
    items: FormPagePropertyItemMultipleSelectionItemDefinition;
    /**
     * 最小選択数. これを下回る選択数だとエラー(ただし非必須の場合は未選択 = 空配列も許容しないといけない）
     */
    minItems?: number;
    /**
     * 最大選択数. これを上回る選択数だとエラー
     */
    maxItems?: number;
    /**
     * 配列内に重複を許すかどうか true固定で入れる https://json-schema.org/understanding-json-schema/reference/array.html#uniqueness 
     */
    uniqueItems?: boolean;
    inputFormat: FormPagePropertyItemMultipleSelectionInputFormat;
    candidates: Array<FormPagePropertyItemMultipleSelectionCandidate>;
    errorMessage?: FormPagePropertyItemMultipleSelectionErrorMessage;
    /**
     * 補助テキストが必須となる選択肢と、選択肢ごとのエラーメッセージの配列. 補助テキストの必須判定に利用
     */
    requiredSubtextMultipleSelection?: Array<FormPagePropertyItemSelectionRequiredSubtext>;
}
export namespace FormPagePropertyItemMultipleSelectionAllOf {
    export type TypeEnum = 'array';
    export const TypeEnum = {
        Array: 'array' as TypeEnum
    };
}



